import type { RouteLocationNormalizedLoaded } from 'vue-router'
import type { Protocol } from '@/libraries/service/protocols'

/* The pseudo-tenant the API answers with every device the signed-in domain can reach: it
 * has no record, devices or accounts of its own. */
export const ALL = 'all'

export const tenantOf = (route: RouteLocationNormalizedLoaded): string =>
  (route.params.tenant as string | undefined) || ALL

/* Only under account/:api(ssh|snmp|http), which the router keeps in lower case. */
export const apiOf = (route: RouteLocationNormalizedLoaded): Protocol['api'] =>
  route.params.api as Protocol['api']
